<template>
  <!-- -->
  <div class="defaultViewStyle">
    <el-tabs v-if="!!id" v-model="activeTab">
      <el-tab-pane lazy name="info" label="推荐方案">
        <solution-info :id="id" />
      </el-tab-pane>
      <el-tab-pane lazy name="customer" label="关联客户">
        <solution-relation :id="id" />
      </el-tab-pane>
    </el-tabs>
    <solution-info v-else :id="id" @changeId="changeId"/>
  </div>
</template>

<script>
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import SolutionInfo from "@/views/h5/ai/solution/SolutionInfo.vue";
import SolutionRelation from "@/views/h5/ai/solution/SolutionRelation.vue";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    SolutionInfo, SolutionRelation
  },
  data() {
    return {
      id: "",
      activeTab: "info",
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (!Util.loadPageData(this)) { // 加载缓存数据失败，初始化页面

    }
    this.id = this.route.query.id;
  },
  methods: {
    changeId(id) {
      this.id = id;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/el-tabs.scss";
.detail{

}
</style>
